import script from "./ProjectDesign.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectDesign.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectDesign.vue?vue&type=style&index=0&id=4e26a0de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e26a0de"]])

export default __exports__